import type { ReactNode } from 'react';

const brands = [
  { name: 'Visa', mark: VisaMark },
  { name: 'Mastercard', mark: MastercardMark },
  { name: 'Elo', mark: EloMark },
  { name: 'Hipercard', mark: HipercardMark },
  { name: 'American Express', mark: AmexMark },
] as const;

function Badge({ children }: { children: ReactNode }) {
  return (
    <span className="inline-flex h-6 w-9 items-center justify-center overflow-hidden rounded-[4px] bg-white ring-1 ring-black/10">
      {children}
    </span>
  );
}

function VisaMark() {
  return (
    <svg viewBox="0 0 36 24" className="h-full w-full" aria-hidden>
      <rect width="36" height="24" fill="#1A1F71" />
      <text
        x="18"
        y="16"
        textAnchor="middle"
        fill="#fff"
        fontSize="9"
        fontWeight="700"
        fontStyle="italic"
        fontFamily="Arial, sans-serif"
      >
        VISA
      </text>
    </svg>
  );
}

function MastercardMark() {
  return (
    <svg viewBox="0 0 36 24" className="h-full w-full" aria-hidden>
      <rect width="36" height="24" fill="#fff" />
      <circle cx="14.5" cy="12" r="6.5" fill="#EB001B" />
      <circle cx="21.5" cy="12" r="6.5" fill="#F79E1B" />
      <path
        d="M18 7.2a6.5 6.5 0 0 1 0 9.6 6.5 6.5 0 0 1 0-9.6z"
        fill="#FF5F00"
      />
    </svg>
  );
}

function EloMark() {
  return (
    <svg viewBox="0 0 36 24" className="h-full w-full" aria-hidden>
      <rect width="36" height="24" fill="#000" />
      <text
        x="18"
        y="16"
        textAnchor="middle"
        fill="#FFCB05"
        fontSize="10"
        fontWeight="800"
        fontFamily="Arial, sans-serif"
      >
        elo
      </text>
    </svg>
  );
}

function HipercardMark() {
  return (
    <svg viewBox="0 0 36 24" className="h-full w-full" aria-hidden>
      <rect width="36" height="24" fill="#B3131B" />
      <text
        x="18"
        y="15.5"
        textAnchor="middle"
        fill="#fff"
        fontSize="6.5"
        fontWeight="700"
        fontFamily="Arial, sans-serif"
      >
        hiper
      </text>
    </svg>
  );
}

function AmexMark() {
  return (
    <svg viewBox="0 0 36 24" className="h-full w-full" aria-hidden>
      <rect width="36" height="24" fill="#2E77BC" />
      <text
        x="18"
        y="15.5"
        textAnchor="middle"
        fill="#fff"
        fontSize="7"
        fontWeight="700"
        fontFamily="Arial, sans-serif"
      >
        AMEX
      </text>
    </svg>
  );
}

export default function AcceptedCardBrands() {
  return (
    <ul
      className="flex flex-wrap items-center gap-1.5"
      aria-label="Bandeiras aceitas: Visa, Mastercard, Elo, Hipercard e American Express"
    >
      {brands.map(({ name, mark: Mark }) => (
        <li key={name}>
          <Badge>
            <span className="sr-only">{name}</span>
            <Mark />
          </Badge>
        </li>
      ))}
    </ul>
  );
}
